import * as React from "react"
import { Link } from "gatsby"
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import {navStyle,colorWhite,colorBlack,barlow} from './communityHeader.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import ApplyButton from '../components/applyButton'
import AddressComponent from '../components/tiny_components/addressComponent'
import PhoneComponent from '../components/tiny_components/phoneComponent'
import {reRentCafeLink} from '../utils/helperFunctions'


const Menu = ({address,scroll,active,handleShowHours,isOpen,closedAt,showHours,
    hours,slug,htmlId,phone,opensAt,handleSetActive,isMobile,linkIt,isVirtual,communityName})=>{
    if(slug){
        slug = slug.toLowerCase();
    }

    return(
        <div className={htmlId.length > 0 ? '':"navbar-menu"} id={htmlId}>
            <div className="navbar-start">
                {!isMobile && 
            <PhoneComponent phone={phone} scroll={scroll} active={active} 
            barlow={barlow} colorwhite={colorWhite} colorBlack={colorBlack} />
                }
                {!isMobile && 
            <AddressComponent address={address} scroll={scroll} active={active} barlow={barlow} 
            colorWhite={colorWhite} colorBlack={colorBlack} isVirtual={isVirtual}
            isOpen={isOpen} closedAt={closedAt} opensAt={opensAt} 
            showHours={showHours} hours={hours} handleShowHours={handleShowHours} htmlId={htmlId} />
                }
            </div>
            <div className="navbar-end">
                <ApplyButton slug={slug} communityName={communityName} isInHeader="true" />
                <div className={active ? "dropdown is-active" : "dropdown"}>
                    <div className="dropdown-trigger">
                        <button className={!scroll && !active ? colorWhite +" button is-ghost" : " button is-ghost"} 
                        aria-haspopup="true" aria-controls="dropdown-menu" onClick={()=>{handleSetActive(!active)}} 
                        style={{marginRight:'3rem',position:'relative',top:'0.9rem'}}>
                            <FontAwesomeIcon icon={ faBars } size="1x" />
                        </button>
                    </div>
                    <div className={navStyle+" dropdown-menu"} id="dropdown-menu" role="menu">
                        <div className="dropdown-content" style={{paddingBottom:'2rem'}}>
                        <br />
                            <div className="columns">
                                <div className="column">
                                </div>
                                <div className="column">
                                    <AnchorLink
                                        to={`${linkIt}#floorplans`}
                                        title="Floorplans"
                                        className={`${colorBlack} dropdown-item ${barlow} community-header-link-floorplans`}
                                        stripHash // Optional, removes the hash from the URL after navigation
                                    >
                                        Floorplans
                                    </AnchorLink>
                                    <AnchorLink
                                        to={`${linkIt}#amenities`}
                                        title="Amenities"
                                        className={`${colorBlack} dropdown-item ${barlow} community-header-link-amenities`}
                                    >
                                        Amenities
                                    </AnchorLink>
                                    <Link to={`${linkIt}gallery/`} className={`${colorBlack} dropdown-item ${barlow} community-header-link-gallery`}>Photo Gallery</Link>
                                    <AnchorLink
                                    to={`${linkIt}#sitemap`}
                                    title="Community Map"
                                    className={`${colorBlack} dropdown-item ${barlow} community-header-link-map`}
                                    >
                                        Community Map
                                    </AnchorLink>
                                </div>
                                <div className="column">
                                    <AnchorLink
                                    to={`${linkIt}#sisters`}
                                    title="Sister Communities"
                                    className={`${colorBlack} dropdown-item ${barlow} community-header-link-sister`}
                                    >
                                        Sister Communities
                                    </AnchorLink>
                                    <Link to={`${linkIt}contact/`} className={`${colorBlack} dropdown-item ${barlow} community-header-link-contact`}>Contact Us</Link>
                                    {!isMobile &&
                                    <p className={colorBlack+" dropdown-item "+barlow}>{phone}</p>
                                    }
                                </div>
                                <div className="column">
                                    <div style={{paddingRight: '1rem',  paddingLeft: isMobile ? '0.75rem' : '0'}}>
                                        <a href={reRentCafeLink(slug)} target="_blank" className={`button is-link is-inline-block ${barlow} community-header-link-resident-login has-text-white`} style={{width: 'auto', margin: '0.5rem 0'}}>Resident Login</a>
                                    </div>
                                    <Link to="/" className={`${colorBlack} dropdown-item ${barlow} community-header-link-home`}>McKinley Home</Link>
                                </div>
                                <div className="column">
                                    {isMobile && 
                                    <div>
            <PhoneComponent phone={phone} scroll={scroll} active={active} barlow={barlow} colorwhite={colorWhite} colorBlack={colorBlack} />
            <AddressComponent address={address} scroll={scroll} active={active} barlow={barlow} 
            colorWhite={colorWhite} colorBlack={colorBlack} 
            isOpen={isOpen} closedAt={closedAt} opensAt={opensAt} 
            showHours={showHours} hours={hours} handleShowHours={handleShowHours} htmlId={htmlId} />
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </div>
 
    )
}

export default Menu